// frontend/src/pages/portfolio/components/SectionEyebrow.tsx
import React from "react";
import { Sparkles } from "lucide-react";
import { eyebrowClass } from "./styles";

interface SectionEyebrowProps {
  children: React.ReactNode;
  icon?: React.ComponentType<{ className?: string; "aria-hidden"?: boolean }>;
  className?: string;
}

const SectionEyebrow: React.FC<SectionEyebrowProps> = ({
  children,
  icon: Icon = Sparkles,
  className = "",
}) => {
  return (
    <p className={`${eyebrowClass} ${className}`}>
      <Icon className="h-3.5 w-3.5" aria-hidden />
      {children}
    </p>
  );
};

export default SectionEyebrow;
